// extracted by mini-css-extract-plugin
export default {"panel":"PositionsTabPanel_panel__7j5Sl"};